import {
  PerformanceComment,
  PerformanceCommentCreateRequest,
  PerformanceCommentsByFilter,
} from '../../types/app/performanceComment.types';

import { api } from '../core/api';

export const getList = (id?: number) =>
  api
    .get<PerformanceComment[]>(`PerformanceComment/GetList?parentId=${id}`)
    .then((res) => res.data);

export const getListFiltered = (data: PerformanceCommentsByFilter) =>
  api
    .get<PerformanceComment[]>(
      `PerformanceComment/GetListFiltered?assetId=${data.assetId}&from=${data.from}&to=${data.to}`,
    )
    .then((res) => res.data);

export const createItem = (data: PerformanceCommentCreateRequest) =>
  api.post(`PerformanceComment/CreateItem`, data).then((res) => res.data);
